import { defineStore } from 'pinia'
import http from '../utils/http';
import { ElMessage,ElLoading } from 'element-plus'

export const useGameStore = defineStore('game', {
  state: () => ({
    users:{
      token:undefined,
      uid:undefined,
    },
    userInfoCacheData: null,
    userInfoCacheTs: 0,
    userInfoPending: null,
    roomInfo:{},
    roomOdds:{},
    agent:undefined,
    homeInfo:undefined,
  }),
  getters: {
    userCoin:(state)=>state.users.balance, // 余额单位是分，不做转换，由显示层处理
    gameList:(state)=>state.storeCommon.gamelist,
    token:(state)=>state.users.token,
    uid:(state)=>state.users.uid,
  },
  actions: {
    saveToken(token)
    {
      this.users.token = token
      if (token) {
        // 存储 token 到 localStorage
        localStorage.setItem("token", token)
        console.log("Token 已保存到 localStorage:", token)
      } else {
        // 清除 localStorage 中的 token
        localStorage.removeItem("token")
        console.log("Token 已从 localStorage 删除")
      }
    },

    saveUid(uid)
    {
      this.users.uid = uid
      if (uid) {
        // 存储 uid 到 localStorage
        localStorage.setItem("uid", uid)
        console.log("Uid 已保存到 localStorage:", uid)
      } else {
        // 清除 localStorage 中的 uid
        localStorage.removeItem("uid")
        console.log("Uid 已从 localStorage 删除")
      }
    },

    getUid()
    {
      // 优先从内存获取
      if (this.users.uid) {      
        return this.users.uid
      }
      
      // 从 localStorage 读取
      const uidFromStorage = localStorage.getItem("uid")
      if (uidFromStorage) {        
        this.users.uid = uidFromStorage
        return uidFromStorage
      }
      
      console.warn('没有找到有效的 uid')
      return null
    },

    getToken()
    {
      // 优先从内存获取
      if (this.users.token && this.users.token != '') {
        console.log('从内存获取 token:', this.users.token.substring(0, 20) + '...')
        return this.users.token
      }
      
      // 从 localStorage 读取
      const tokenFromStorage = localStorage.getItem("token")
      if (tokenFromStorage) {
        console.log('从 localStorage 获取 token:', tokenFromStorage.substring(0, 20) + '...')
        this.users.token = tokenFromStorage
        return tokenFromStorage
      }
      
      console.warn('没有找到有效的 token')
      return null
    },
    
    async login(param) {
      let loadHandle = ElLoading.service({
        lock: true,
        text: '',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        console.log('正在发送登录请求:', param);
        const response = await http.post('/user/login', param);

        loadHandle.close()
        console.log('登录响应:', response);
        
        if (response.data && response.data.code == 0) {
          this.users = response.data.data
          this.saveToken(this.users.token)
          this.saveUid(this.users.uid)
          ElMessage.success('登录成功！')
          return response.data
        }
        else
        {
          const errorMsg = response.data?.message || '登录失败';
          console.error('登录返回错误代码:', response.data?.code, errorMsg);
          ElMessage.error(errorMsg)
          return Promise.reject(errorMsg)
        }
      } catch (error) {
        loadHandle.close()
        console.error('登录请求异常:', error);
        console.error('错误详情:', {
          message: error.message,
          code: error.code,
          status: error.response?.status,
          data: error.response?.data,
          url: error.config?.url,
          baseURL: error.config?.baseURL,
        });
        
        // 提供更友好的错误提示
        let errorMessage = '登录失败！';
        if (error.response) {
          errorMessage = error.response.data?.message || `服务器错误 (${error.response.status})`;
        } else if (error.request) {
          errorMessage = '网络错误，请检查网络连接';
        } else {
          errorMessage = error.message;
        }
        
        ElMessage.error(errorMessage)
        return Promise.reject(error)
      }
    },

    async loginOut(param) {
      try {
        const response = await http.post('/user/logout', param);
        console.log("logout response:", response)
      } catch (error) {
        console.error('logout error:', error);
      } finally {
        // 无论成功或失败，都清除本地 token 和 uid
        this.saveToken(null)
        this.saveUid(null)
        // 重定向到登录页（根路径）
        window.location.href = '/'
      }
    },

    async register(param) {
      let loadHandle = ElLoading.service({
        lock: true,
        text: '',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        const response = await http.post('/user/register',param);
        console.warn(">>>>>>register>>>",response)
        loadHandle.close()
        if (response.data && response.data.code == 0) {
          this.users = response.data.data;
          this.saveToken(this.users.token)
          ElMessage.success('注册成功！')
          return response.data
        }
        else
        {
          ElMessage.error('注册失败！' + response.data.err)
        }
      } catch (error) {
        console.error('Error fetching users:', error);
        ElMessage.error('注册失败！')
        loadHandle.close()
      }
    },

    async _fetchUserInfo({ silent = false } = {}) {
      const now = Date.now()

      const elapsed = now - this.userInfoCacheTs

      // 命中缓存（5s 内）
      if (this.userInfoCacheData && elapsed < 5000) {
        return Promise.resolve(this.userInfoCacheData)
      }

      // 返回正在进行的请求，避免重复发送
      if (this.userInfoPending) {
        return this.userInfoPending
      }

      // 若无缓存但刚请求过，直接返回缓存占位（可为 null）避免 5s 内重复打点
      if (!this.userInfoCacheData && elapsed < 5000) {
        return Promise.resolve(this.userInfoCacheData)
      }

      // 发送新请求并记录 pending
      // 记录请求发起时间用于节流
      this.userInfoCacheTs = now

      this.userInfoPending = http.get('/user/info')
        .then((response) => {
          console.log('userInfo response:', response)
          if (response.data && response.data.code == 0) {
            for (const key in response.data.data) {
              if (!Object.hasOwn(response.data.data, key)) continue
              this.users[key] = response.data.data[key]
            }
            this.userInfoCacheData = response.data
            this.userInfoCacheTs = Date.now()
            return response.data
          }
          if (!silent) {
            ElMessage.error('网络错误,请检查您的网络！')
          }
          return response.data
        })
        .catch((error) => {
          console.error('userInfo error:', error)
          if (!silent) {
            ElMessage.error(error.message)
          }
          return error
        })
        .finally(() => {
          this.userInfoPending = null
        })

      return this.userInfoPending
    },

    async userInfo() {
      return this._fetchUserInfo({ silent: false })
    },

    async userInfoSilent() {
      return this._fetchUserInfo({ silent: true })
    },

    async modifyPassword(param) {
      let loadHandle = ElLoading.service({
        lock: true,
        text: '',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        const response = await http.post('/user/resetpwd',param);
        console.warn(">>>>>>modifyPassword>>>",JSON.stringify(param),response)
        loadHandle.close()
        if (response.data && response.data.code == 0) {
          ElMessage.success('修改密码成功！')
          return response.data
        }
        else {
          ElMessage.error('修改密码失败！')
        }
      } catch (error) {
        console.error('Error fetching users:', error);
        loadHandle.close()
        ElMessage.error('修改密码失败！')
      }
    },

    async getGameList(showLoading = true) {
      const CACHE_KEY = 'homeInfo'
      const CACHE_TIMESTAMP_KEY = 'homeInfo_timestamp'
      const CACHE_DURATION = 3 * 60 * 1000 // 3分钟缓存

      // 先检查缓存是否有效
      const cachedData = localStorage.getItem(CACHE_KEY)
      const cachedTimestamp = localStorage.getItem(CACHE_TIMESTAMP_KEY)
      
      if (cachedData && cachedTimestamp) {
        try {
          const timestamp = parseInt(cachedTimestamp, 10)
          const now = Date.now()
          const age = now - timestamp
          
          // 如果缓存未过期（3分钟内），直接返回缓存数据
          if (age < CACHE_DURATION) {
            const homeInfo = JSON.parse(cachedData)
            this.homeInfo = homeInfo
            return homeInfo
          }
        } catch (e) {
          console.warn('缓存数据解析失败:', e)
          // 清除无效缓存
          localStorage.removeItem(CACHE_KEY)
          localStorage.removeItem(CACHE_TIMESTAMP_KEY)
        }
      }

      // 缓存过期或不存在，从服务器获取数据
      let loadHandle = null
      if (showLoading) {
        loadHandle = ElLoading.service({
          lock: true,
          text: '',
          background: 'rgba(0, 0, 0, 0.7)',
        })
      }

      try {
        const response = await http.get('/game/index');
        if (loadHandle) loadHandle.close()
        console.warn(">>>>>>gameindex>>>",response)
        if (response.data && response.data.code == 0) {
          let homeInfo = response.data.data
          this.homeInfo = homeInfo
          // 保存数据和时间戳
          localStorage.setItem(CACHE_KEY, JSON.stringify(homeInfo))
          localStorage.setItem(CACHE_TIMESTAMP_KEY, Date.now().toString())
          return homeInfo
        }
        else {
          // 如果请求失败但有缓存，返回缓存数据（即使过期也返回）
          if (cachedData) {
            try {
              const homeInfo = JSON.parse(cachedData)
              this.homeInfo = homeInfo
              return homeInfo
            } catch (e) {
              console.warn('使用缓存数据失败:', e)
            }
          }
          ElMessage.error('网络错误,请检查您的网络！')
          return null
        }
      } catch (error) {
        console.error('获取游戏列表失败:', error);
        if (loadHandle) loadHandle.close()
        
        // 如果请求失败但有缓存，返回缓存数据（即使过期也返回）
        if (cachedData) {
          try {
            const homeInfo = JSON.parse(cachedData)
            this.homeInfo = homeInfo
            return homeInfo
          } catch (e) {
            console.warn('使用缓存数据失败:', e)
          }
        }
        
        if (showLoading) {
          ElMessage.error('网络错误,请检查您的网络！')
        }
        return null
      }
    },

    async gameInfo(gameid=1, showLoading = true) {
      let loadHandle = null
      if (showLoading) {
        loadHandle = ElLoading.service({
          lock: true,
          text: '',
          background: 'rgba(0, 0, 0, 0.7)',
        })
      }
      try {
        const response = await http.get('/game/info?gameid='+gameid);
        if (loadHandle) loadHandle.close()
        if (response.data && response.data.code === 0) {
          this.roomInfo = response.data.data
          this.users.balance = this.roomInfo.balance
          return response.data
        }
        else
        {
          if (showLoading) {
            ElMessage.error('网络错误,请检查您的网络！')
          }
        }

        console.warn(">>>>>>gameInfo>>>",response)
      } catch (error) {
        console.error('Error fetching users:', error);
        if (showLoading) {
          ElMessage.error('网络错误,请检查您的网络！')
        }
        if (loadHandle) loadHandle.close()
      }
    },

    async gameRoundList(gameid=1) {
      try {
        const response = await http.get('/game/roundlist?gameid='+gameid,{
          headers:{
            'Content-Type': 'application/x-www-form-urlencoded',
            "Authorization":this.getToken(),
          }
        });
        console.warn(">>>>>>gameRoundList>>>",response)
        if (response.data && response.data.code === 0) {
          console.warn(">>>>>>gameRoundList>return>>",response.data)
          return response.data
        }
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    },

    async gameOddList(gameid=1) {
      let loadHandle = ElLoading.service({
        lock: true,
        text: '',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        const response = await http.get('/game/oddlist?gameid='+gameid);
        loadHandle.close()
        if (response.data && response.data.code === 0) {
          this.roomOdds = response.data.data
          return response.data
        }
        else
        {
          ElMessage.error('网络错误,请检查您的网络！')
        }
        
        console.warn(">>>>>>gameOddList>>>",response)
      } catch (error) {
        console.error('Error fetching users:', error);
        loadHandle.close()
        ElMessage.error('网络错误,请检查您的网络！')
      }
    },

    async gameBetLog(day = 1) {
      try {
        const response = await http.get('/game/betlog?day='+day,{
          headers:{
            'Content-Type': 'application/x-www-form-urlencoded',
            "Authorization":this.getToken(),
          }
        });
        console.warn(">>>>>>gameBetLog>>>",response)
        if (response.data && response.data.code === 0) {
          return response.data
        }
        else
        {
          ElMessage.error('网络错误,请检查您的网络！')
        }
        
      } catch (error) {
        console.error('Error fetching users:', error);
        ElMessage.error('网络错误,请检查您的网络！')
      }
    },

    async userRecordList(type = 1,page=1,page_size=10) {
      let loadHandle = ElLoading.service({
        lock: true,
        text: '',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        console.log('userRecordList 参数:', { type, page, page_size })
        
        const response = await http.get('/account/loglist?type='+type+"&page="+page+"&page_size="+page_size,{
          headers:{
            'Content-Type': 'application/x-www-form-urlencoded',
            "Authorization":this.getToken(),
          }
        });
        loadHandle.close()

        console.log("userRecordList 响应:", response)
        
        if (response.data && response.data.code === 0) {
          return response.data
        }
        else
        {
          ElMessage.error('获取记录失败')
          return response.data
        }
      } catch (error) {
        console.error('userRecordList 错误:', error);
        loadHandle.close()
        ElMessage.error('网络错误,请检查您的网络！')
        return null
      }
    },

    async sendBet(param) {
      try {
        const response = await http.post('/game/bet',param,{
          headers:{
            "Authorization":this.getToken(),
          }
        });

        console.warn(">>>>>>sendBet>>>",JSON.stringify(param),response)
        if (response.data && response.data.code === 0) {
          ElMessage.success('投注成功！')
          this.users.balance = response.data.data.balance
          return response.data
        }
        else
        {
          if (response.data.code == -1) {
            ElMessage.error('投注失败,' + response.data.err)
          }
          else
          {
            ElMessage.error('投注失败,重新下注！')
          }
          
        }
      } catch (error) {
        console.error('Error fetching users:', error);
        ElMessage.error('投注失败,重新下注！')
      }
    },

    async giveupBet(gameid,roundid) {
      try {
        const response = await http.get('/game/betcancel?gameid='+gameid+"&roundid="+roundid,{
          headers:{
            'Content-Type': 'application/x-www-form-urlencoded',
            "Authorization":this.getToken(),
          }
        });
        console.warn(">>>>>>giveupBet>>>",response)
        if (response.data && response.data.code === 0) {
          ElMessage.success('撤单成功！')
          this.users.balance = response.data.data.balance
          return response.data
        }
        else
        {
          ElMessage.error('撤单失败！')
        }
      } catch (error) {
        console.error('Error fetching users:', error);
        ElMessage.error('撤单失败！')
      }
    },

    async agentCenter(start = '',end = '') {
      console.warn(">>>>start,end>>>",start,end)
      try {
        const response = await http.get('/invite/data?start='+start+"&end="+end,{
          headers:{
            'Content-Type': 'application/x-www-form-urlencoded',
            "Authorization":this.getToken(),
          }
        });
        console.warn(">>>>>>agentCenter>>>",response)
        if (response.data && response.data.code === 0) {
          this.agent = response.data.data
          return response.data
        }
        else
        {
          ElMessage.error('获取代理信息失败！' + response.data.err)
        }
      } catch (error) {
        console.error('Error fetching users:', error);
        ElMessage.error('网络错误,请检查您的网络！')
      }
    },

    async accountIn(pay_type, amount) {
      let loadHandle = ElLoading.service({
        lock: true,
        text: '提交中...',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        const response = await http.get(`/account/in?pay_type=${pay_type}&amount=${amount}`, {
          headers:{
            'Content-Type': 'application/x-www-form-urlencoded',
            "Authorization": this.getToken(),
          }
        });
        loadHandle.close()
        console.log("accountIn response:", response)
        if (response.data && response.data.code === 0) {
          ElMessage.success('充值订单已提交！订单号：' + response.data.data.order_no)
          return response.data
        }
        else {
          ElMessage.error('充值失败！' + (response.data.msg || response.data.err || ''))
          return Promise.reject(response.data)
        }
      } catch (error) {
        console.error('accountIn error:', error);
        loadHandle.close()
        ElMessage.error('网络错误,请检查您的网络！')
        return Promise.reject(error)
      }
    },

    async accountOut(pay_type, amount) {
      let loadHandle = ElLoading.service({
        lock: true,
        text: '提交中...',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        const response = await http.get(`/account/out?pay_type=${pay_type}&amount=${amount}`, {
          headers:{
            'Content-Type': 'application/x-www-form-urlencoded',
            "Authorization": this.getToken(),
          }
        });
        loadHandle.close()
        console.log("accountOut response:", response)
        if (response.data && response.data.code === 0) {
          ElMessage.success('提现订单已提交！订单号：' + response.data.data.order_no)
          return response.data
        }
        else {
          ElMessage.error('提现失败！' + (response.data.msg || response.data.err || ''))
          return Promise.reject(response.data)
        }
      } catch (error) {
        console.error('accountOut error:', error);
        loadHandle.close()
        ElMessage.error('网络错误,请检查您的网络！')
        return Promise.reject(error)
      }
    },

    async getAccountInOutList(type) {
      try {
        const response = await http.get(`/account/inoutlist?type=${type}`, {
          headers:{
            'Content-Type': 'application/x-www-form-urlencoded',
            "Authorization": this.getToken(),
          }
        });
        console.log("getAccountInOutList response:", response)
        if (response.data && response.data.code === 0) {
          return response.data.data || { list: [] }
        }
        else {
          console.error('获取列表失败:', response.data)
          return Promise.reject(response.data)
        }
      } catch (error) {
        console.error('getAccountInOutList error:', error);
        return Promise.reject(error)
      }
    },

    async chatBet(param) {
      try {
        const response = await http.post('/game/chatbet', param, {
          headers: {
            "Authorization": this.getToken(),
          }
        });

        console.warn(">>>>>>chatBet>>>", JSON.stringify(param), response)
        if (response.data && response.data.code === 0) {
          // 更新余额
          this.users.balance = response.data.data.balance
          ElMessage.success(response.data.data.msg || '发送成功！')
          return response.data
        }
        else {
          const errorMsg = response.data?.msg || response.data?.err || '发送失败！'
          ElMessage.error(errorMsg)
          return Promise.reject(response.data)
        }
      } catch (error) {
        console.error('chatBet error:', error);
        ElMessage.error('发送失败,请重试！')
        return Promise.reject(error)
      }
    },

    async getWithdrawIndex() {
      try {
        const response = await http.get('/trans/withdrawindex', {
          headers:{
            'Content-Type': 'application/x-www-form-urlencoded',
            "Authorization": this.getToken(),
          }
        });
        console.log("getWithdrawIndex response:", response)
        if (response.data && response.data.code === 0) {
          return response.data
        }
        else {
          ElMessage.error('获取提现信息失败！' + (response.data.msg || response.data.err || ''))
          return Promise.reject(response.data)
        }
      } catch (error) {
        console.error('getWithdrawIndex error:', error);
        ElMessage.error('网络错误,请检查您的网络！')
        return Promise.reject(error)
      }
    },

    async getRollingList(page = 1, page_size = 20) {
      try {
        const response = await http.get(`/trans/rollingList?page=${page}&page_size=${page_size}`, {
          headers:{
            'Content-Type': 'application/x-www-form-urlencoded',
            "Authorization": this.getToken(),
          }
        });
        console.log("getRollingList response:", response)
        if (response.data && response.data.code === 0) {
          return response.data
        }
        else {
          ElMessage.error('获取打码列表失败！' + (response.data.msg || response.data.err || ''))
          return Promise.reject(response.data)
        }
      } catch (error) {
        console.error('getRollingList error:', error);
        ElMessage.error('网络错误,请检查您的网络！')
        return Promise.reject(error)
      }
    },
  }
})

